// removed by extract-text-webpack-plugin
module.exports = {"modalBodyContainer":"G47c116"};